import React, { createContext, useContext, useState } from "react";
import { OrgInfo } from "./layout";

type BankFeedsContextType = {
  password: string;
  setPassword: (value: string) => void;

  orgInfo: OrgInfo;
  setOrgInfo: (value: OrgInfo) => void;

  showDefaultLogin: boolean;
  setShowDefaultLogin: (value: boolean) => void;

  isSubmitting: boolean;
  setIsSubmitting: (value: boolean) => void;

  isRedirecting: boolean;
  setIsRedirecting: (value: boolean) => void;

  showInstitutionMessage: boolean;
  setShowInstitutionMessage: (value: boolean) => void;

  isFetchingOrgInfo: boolean;
  setIsFetchingOrgInfo: (value: boolean) => void;
};

const BankFeedsContext = createContext<BankFeedsContextType | undefined>(
  undefined,
);

export const BankFeedsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [password, setPassword] = useState<string>("");
  const [orgInfo, setOrgInfo] = useState<OrgInfo>({});
  const [showDefaultLogin, setShowDefaultLogin] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isRedirecting, setIsRedirecting] = useState<boolean>(false);
  const [showInstitutionMessage, setShowInstitutionMessage] =
    useState<boolean>(false);
  const [isFetchingOrgInfo, setIsFetchingOrgInfo] = useState<boolean>(true);

  return (
    <BankFeedsContext.Provider
      value={{
        password,
        setPassword,
        orgInfo,
        setOrgInfo,
        showDefaultLogin,
        setShowDefaultLogin,
        isSubmitting,
        setIsSubmitting,
        isRedirecting,
        setIsRedirecting,
        showInstitutionMessage,
        setShowInstitutionMessage,
        isFetchingOrgInfo,
        setIsFetchingOrgInfo,
      }}
    >
      {children}
    </BankFeedsContext.Provider>
  );
};

export const useBankFeeds = () => {
  const context = useContext(BankFeedsContext);
  if (!context) {
    throw new Error("useBankFeeds must be used within a BankFeedsProvider");
  }
  return context;
};
